import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@tds/core-tooltip';
import { FieldWrapper } from './css';
import Note from '../../note';
import { fieldDoesCustomerSiteHaveAnExistingSecuritySystem } from './../../utils/constant';

const FieldRadio = ({ data }) => {
  const {
    ref,
    name,
    label,
    options,
    required,
    onChange,
    note,
    readonly,
    value: fieldValue,
    disabled,
    tooltip,
    noteAppearsBelowField,
    isShowNoteBackground,
    isItalicNote
  } = data;
  return (
    <FieldWrapper>
      {name === fieldDoesCustomerSiteHaveAnExistingSecuritySystem ? (
        <div
          className="frg-body-font-14px"
          style={{ display: 'inline-flex' }}
          dangerouslySetInnerHTML={{ __html: label.split(',').join(`<br />`) }}
        />
      ) : (
        <p className="frg-body-font-14px" style={{ display: 'inline-flex' }}>
          {label}
          {required && `*`}

          {tooltip && (
            <span style={{ marginLeft: '0.5rem' }}>
              <Tooltip copy="en">{tooltip}</Tooltip>
            </span>
          )}
        </p>
      )}
      {note && note.content && !noteAppearsBelowField && (
        <Note
          type="richText"
          data={note}
          isShowNoteBackground={isShowNoteBackground}
          isItalicNote={isItalicNote}
        />
      )}
      <div id="fieldRadio">
        {options &&
          options.map(item => {
            const {
              fields: { label: itemLabel, value, disabledOption }
            } = item;
            const id = `${name}${itemLabel}`;
            return (
              <Fragment key={id}>
                <input
                  type="radio"
                  ref={ref}
                  id={id}
                  name={name}
                  checked={value === fieldValue}
                  value={value}
                  onChange={onChange}
                  disabled={readonly || disabled || disabledOption}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                <label
                  htmlFor={id}
                  style={{
                    marginBottom: '5px',
                    color: disabledOption && '#999'
                  }}
                >
                  {itemLabel}
                </label>
              </Fragment>
            );
          })}
      </div>
      {note && note.content && noteAppearsBelowField && (
        <Note
          type="richText"
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
    </FieldWrapper>
  );
};

FieldRadio.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    readonly: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    tooltip: PropTypes.string.isRequired,
    noteAppearsBelowField: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          value: PropTypes.string.isRequired
        })
      })
    ).isRequired,
    isShowNoteBackground: PropTypes.bool
  }).isRequired
};

export default FieldRadio;
